<script>
  import { getContext } from 'svelte';
  import ExportPopup from './ExportPopup.svelte';

  const { open } = getContext('simple-modal');

  export let export_excel;
  export let export_weekly_excel;
  export let u_n;
  export let year_buttons;
  export let salesteams_all;
  export let mein_name;
  export let origin_all_sales_members;
  export let group_rights;
  export let ghais_special_access;
  export let individual_rights;

  const showSurprise = () =>
    open(ExportPopup, {
      export_excel: export_excel,
      export_weekly_excel: export_weekly_excel,
      u_n: u_n,
      year_buttons: year_buttons,
      salesteams_all: salesteams_all,
      mein_name: mein_name,
      origin_all_sales_members: origin_all_sales_members,
      group_rights: group_rights,
      ghais_special_access: ghais_special_access,
      individual_rights: individual_rights,
    });
</script>

<div class="flex-row">
  {#if JSON.stringify(group_rights).includes('ALL')}
    <button on:click={export_excel} class="btn btn-primary" style="margin-left:35px">export excel</button>
  {/if}
  <button class="btn btn-primary" on:click={showSurprise}>Export Weekly/Monthly</button>
</div>
